import type { IFlyerCatalogueResources } from "./FlyerCatalogue.Resources";

export const FlyerCatalogueResourcesEn: IFlyerCatalogueResources = {
    paginationText: "Page {page} / {totalPages}",
    showFlyerText: "Show whole flyer",
    flyerPages: "Flyer pages",
    navigateToBrand: "More in {brandName}",
    share: "Share",
};
